import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Calendar, ArrowLeft, ExternalLink, Loader2 } from 'lucide-react';
import { getNewsItem, getNews, resolveImg } from '../lib/api';

import { useLang } from '../lib/i18n';
const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
};

export default function NoticiaDetalle() {
  const { ui } = useLang();
  const { slug } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getNewsItem(slug)
      .then((d) => {
        setItem(d);
        return getNews(6);
      })
      .then((all) => setRelated(all.filter((x) => x.slug !== slug && x.id !== slug).slice(0, 3)))
      .catch(() => navigate('/noticias'))
      .finally(() => setLoading(false));
  }, [slug, navigate]);

  if (loading) return <div className="min-h-[60vh] flex items-center justify-center text-[#c9a063]"><Loader2 size={32} className="animate-spin" /></div>;
  if (!item) return null;

  return (
    <div>
      <article className="max-w-3xl mx-auto px-6 md:px-10 pt-16 pb-20">
        <Link to="/noticias" className="inline-flex items-center gap-2 text-white/70 hover:text-[#c9a063] text-[12px] uppercase tracking-[0.25em] mb-8 transition-colors"><ArrowLeft size={14} /> {ui('btn.back_to_news')}</Link>
        <div className="text-[#c9a063] gd-eyebrow mb-3 inline-flex items-center gap-2"><Calendar size={12} /> <span className="capitalize">{formatDate(item.date)}</span></div>
        <h1 className="font-serif-display text-4xl md:text-5xl text-white leading-tight mb-8">{item.title}</h1>
        {item.image && (
          <div className="relative aspect-[16/9] overflow-hidden bg-[#1a1a1d] mb-10">
            <img src={resolveImg(item.image)} alt={item.title} className="w-full h-full object-cover" />
          </div>
        )}
        <div className="news-content text-white/80 text-lg leading-relaxed" dangerouslySetInnerHTML={{ __html: item.content || '' }} />
        {item.link && (
          <div className="mt-10">
            <a href={item.link} target="_blank" rel="noreferrer" className="gd-btn-gold inline-flex items-center gap-2 px-6 py-3 text-[11px] uppercase tracking-[0.3em] font-sans-ui font-medium">{ui('btn.more_info')} <ExternalLink size={12} /></a>
          </div>
        )}
      </article>

      {related.length > 0 && (
        <section className="py-16 px-6 md:px-10 bg-[#0a0a0b] border-t border-white/5">
          <div className="max-w-6xl mx-auto">
            <div className="gd-eyebrow mb-6">{ui('news.other')}</div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {related.map((n) => (
                <Link to={`/noticias/${n.slug || n.id}`} key={n.id} className="gd-card group overflow-hidden">
                  <div className="relative aspect-[16/9] overflow-hidden bg-[#1a1a1d]">
                    {n.image && <img src={resolveImg(n.image)} alt={n.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />}
                  </div>
                  <div className="p-5">
                    <div className="text-[10px] tracking-[0.3em] text-[#c9a063] uppercase mb-2">{formatDate(n.date)}</div>
                    <h4 className="font-serif-display text-lg text-white group-hover:text-[#c9a063] transition-colors">{n.title}</h4>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
